import {
    AssetRv,
    CollateralsAssetsResponse,
} from 'api/application/getCollateralsAssets'
import AssetCondition from 'state/enums/AssetCondition'
import RvType from 'state/enums/RvType'

export interface RvAsset {
    asset_value: number
    data_source: string
    make: string
    makeId: string
    mileage: string
    model: string
    modelId: string
    rv: number
    rv_type: RvType | null
    year: string
}

interface ConvertedCollateralValues {
    condition: string
    makeId: string
    multiUnit?: boolean
    primary: RvAsset
    secondary?: RvAsset
    vehicleType: string
}

export default function convertCollateralValues(
    collaterals: CollateralsAssetsResponse[],
): ConvertedCollateralValues | null {
    if (collaterals.length < 1) {
        return null
    }

    const converted = collaterals.map(
        ({ asset, asset_value, data_source }): RvAsset => {
            const {
                make,
                make_id,
                mileage,
                model,
                model_id,
                rv,
                rv_type,
                year,
            } = asset as AssetRv

            return {
                asset_value: Number(asset_value),
                data_source,
                make,
                makeId: make_id || '',
                mileage: mileage ? String(mileage) : '',
                model,
                modelId: model_id || '',
                rv,
                rv_type,
                year: String(year),
            }
        },
    )

    return {
        condition:
            collaterals[0].asset.condition === AssetCondition.NEW
                ? 'new'
                : 'used',
        makeId: converted[0].makeId,
        multiUnit: converted.length > 1,
        primary: converted[0],
        secondary: converted?.[1],
        vehicleType: converted[0].rv_type ?? '',
    }
}
